import { Menu } from "@headlessui/react";
import { PropsWithChildren } from "react";

export const MenuDropdownButton = ({
  children,
  className
}: PropsWithChildren<{ className?: string }>) => (
  <Menu.Button
    as="div"
    className={`z-10 w-full cursor-pointer focus:outline-none ${className}`}
  >
    {children}
  </Menu.Button>
);
